export default __webpack_public_path__ + "static/media/blog-1.a9420ee4.jpg";